module.exports = __webpack_public_path__ + "img/baiwan-en.ff1880e1.webp";